export default "__VITE_ASSET__D2VcRB_X__"